import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  background?: 'white' | 'light' | 'primary' | 'dark';
  className?: string;
  id?: string;
}

const Section: React.FC<SectionProps> = ({ 
  children, 
  background = 'white', 
  className = '',
  id 
}) => {
  const getBackgroundClasses = () => {
    switch (background) {
      case 'light':
        return 'bg-gray-50';
      case 'primary':
        return 'bg-primary text-white';
      case 'dark':
        return 'bg-gray-900 text-white';
      default:
        return 'bg-white';
    }
  };

  return (
    <section 
      id={id}
      className={`py-16 ${getBackgroundClasses()} ${className}`}
    >
      <div className="container mx-auto px-4">
        {children}
      </div>
    </section>
  );
};

export default Section;